import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class DateValidator {
  static months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  
  static validateDateOfBirth: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const day = control.get('day');
    const month = control.get('month');
    const year = control.get('year');

    const checkValueExist = (value: string) => {
      return value != undefined && value != null && value.length > 0;
    }

    if (checkValueExist(day?.value) && checkValueExist(month?.value) && checkValueExist(year?.value)) {
      const monthNumeric = DateValidator.getMonthValue(month?.value);

      if (monthNumeric === null) {
        DateValidator.setInvalidDateError(day, month, year);
        return { invalidDate: true };
      }

      const date = new Date(Date.UTC(Number(year?.value), monthNumeric, Number(day?.value)));

      if (!DateValidator.isDateValid(date, day?.value, month?.value, year?.value)) {
        DateValidator.setInvalidDateError(day, month, year);
        return { invalidDate: true };
      }
    }

    DateValidator.removeError(day, "invalidDate");
    DateValidator.removeError(month, "invalidDate");
    DateValidator.removeError(year, "invalidDate");
    return null;
  }

  static dateOfBirthRequired: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const day = control.get('day');
    const month = control.get('month');
    const year = control.get('year');

    const checkValueExist = (value: string) => {
      return value != undefined && value != null && value.length > 0;
    }

    if (checkValueExist(day?.value) && checkValueExist(month?.value) && checkValueExist(year?.value)) {
      DateValidator.removeError(day, "dateRequired");
      DateValidator.removeError(month, "dateRequired");
      DateValidator.removeError(year, "dateRequired");
      return null;
    }

    if (!checkValueExist(day?.value)) {
      day?.setErrors({ dateRequired: true });
    }
    if (!checkValueExist(month?.value)) {
      month?.setErrors({ dateRequired: true });
    }
    if (!checkValueExist(year?.value)) {
      year?.setErrors({ dateRequired: true });
    }

    return { dateRequired: true };
  }

    
  static removeError(control: AbstractControl | null, error: string) {
    const err = control?.errors;
    if (err) {
      delete err[error];
      if (!Object.keys(err).length) {
        control?.setErrors(null);
      } else {
        control?.setErrors(err);
      }
    }
  }

  
  static getMonthValue(month: string): number | null {
    const monthNumeric = DateValidator.months.findIndex(m => m === month);
    return monthNumeric !== -1 ? monthNumeric : null;
  }

  
  static isDateValid(date: Date, day: string, month: string, year: string): boolean {
    return (
      date.getUTCDate() === Number(day) &&
      DateValidator.months[date.getUTCMonth()] === month &&
      date.getUTCFullYear() === Number(year)
    );
  }

 
  static setInvalidDateError(day: AbstractControl | null, month: AbstractControl | null, year: AbstractControl | null) {
    day?.setErrors({ invalidDate: true });
    month?.setErrors({ invalidDate: true });
    year?.setErrors({ invalidDate: true });
  }
}
